import { Alert, Button, Collapse, Typography } from '@mui/material';
import { useReconnectAgent } from '../hooks/useAgentHealthStatus';
import { AgentTenantMismatch, useAgentTenantMismatch } from '../hooks/useAgentTenantMismatch';

function mismatchMessage(mismatch: AgentTenantMismatch): string {
  if (mismatch.agentTenantName && mismatch.sessionTenantName) {
    return `The assistant is connected to ${mismatch.agentTenantName}, but this session is on ${mismatch.sessionTenantName}.`;
  }
  return 'The assistant is connected to a different workspace than this session.';
}

/** Warns when the agent WS connection is bound to a different tenant than the
 *  app session (see useAgentTenantMismatch). Reconnecting fetches a fresh
 *  token; the server re-reports its identity and the banner clears itself
 *  once the tenants agree. */
export function AgentTenantMismatchAlert() {
  const mismatch = useAgentTenantMismatch();
  const { handleRetry, isRetrying } = useReconnectAgent();

  return (
    <Collapse in={mismatch !== null} sx={{ position: 'sticky', bottom: 0, zIndex: 1 }}>
      {mismatch ? (
        <Alert severity='warning' sx={{ minHeight: '3.5rem' }}>
          {mismatchMessage(mismatch)} Conversations may not load until you reconnect.
          <Typography variant='body2' alignItems='center'>
            <Button variant='text' onClick={handleRetry} disabled={isRetrying}>
              {isRetrying ? 'Reconnecting...' : 'Reconnect'}
            </Button>
          </Typography>
        </Alert>
      ) : (
        <div style={{ height: '1px' }} />
      )}
    </Collapse>
  );
}
